import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ChevronLeft, ChevronRight } from 'lucide-react';
import Header from './components/Header8';
import Footer from './components/Footer8';

const Template8Shop = () => {
    const navigate = useNavigate();
    const [activeFilter, setActiveFilter] = useState('All');
    const [sortBy, setSortBy] = useState('featured');
    const [currentPage, setCurrentPage] = useState(1);
    const [wishlist, setWishlist] = useState({});
    const [hoveredCard, setHoveredCard] = useState(null);

    const categories = ['All', 'Anarkalis', 'Sarees', 'Lehengas', 'Kurta Sets', 'Festive Wear'];

    const sortOptions = [
        { value: 'featured', label: 'Featured' },
        { value: 'price-low', label: 'Price: Low to High' },
        { value: 'price-high', label: 'Price: High to Low' },
        { value: 'newest', label: 'Newest First' },
    ];

    const products = [
        { id: 1, name: 'Rose Silk Anarkali', category: 'Anarkalis', price: 7499, badge: 'NEW', image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=800' },
        { id: 2, name: 'Designer Banarasi Saree', category: 'Sarees', price: 12999, image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=800' },
        { id: 3, name: 'Bridal Lehenga Set', category: 'Lehengas', price: 24999, badge: 'BESTSELLER', image: 'https://images.pexels.com/photos/3014853/pexels-photo-3014853.jpeg?auto=compress&cs=tinysrgb&w=800' },
        { id: 4, name: 'Festive Palazzo Suit', category: 'Festive Wear', price: 4999, image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=800' },
        { id: 5, name: 'Chanderi Silk Dupatta Set', category: 'Kurta Sets', price: 6499, badge: 'NEW', image: 'https://images.pexels.com/photos/6712360/pexels-photo-6712360.jpeg?auto=compress&cs=tinysrgb&w=800' },
        { id: 6, name: 'Embroidered Anarkali Gown', category: 'Anarkalis', price: 8999, image: 'https://images.pexels.com/photos/7275385/pexels-photo-7275385.jpeg?auto=compress&cs=tinysrgb&w=800' },
        { id: 7, name: 'Zari Work Wedding Saree', category: 'Sarees', price: 18500, image: 'https://images.pexels.com/photos/8953474/pexels-photo-8953474.jpeg?auto=compress&cs=tinysrgb&w=800' },
        { id: 8, name: 'Floral Print Kurta Set', category: 'Kurta Sets', price: 2499, image: 'https://images.pexels.com/photos/2955375/pexels-photo-2955375.jpeg?auto=compress&cs=tinysrgb&w=800' },
    ];

    const filteredProducts = activeFilter === 'All' ? products : products.filter(p => p.category === activeFilter);

    const sortedProducts = [...filteredProducts].sort((a, b) => {
        if (sortBy === 'price-low') return a.price - b.price;
        if (sortBy === 'price-high') return b.price - a.price;
        return 0;
    });

    const toggleWishlist = (e, productId) => {
        e.stopPropagation();
        setWishlist(prev => ({ ...prev, [productId]: !prev[productId] }));
    };

    const totalPages = 3;

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=DM+Sans:wght@300;400;500;700&display=swap');
            `}</style>

            <div style={{ fontFamily: "'DM Sans', sans-serif" }} className="min-h-screen bg-white">
                <Header />

                <main className="pt-[100px] pb-16">
                    {/* Hero Banner */}
                    <div className="text-center py-12 lg:py-16 px-4" style={{ backgroundColor: '#FDF2F8' }}>
                        <p className="text-xs font-medium tracking-[0.3em] uppercase mb-3" style={{ color: '#BE185D' }}>Curated for you</p>
                        <h1
                            style={{ fontFamily: "'Libre Baskerville', serif" }}
                            className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-3"
                        >
                            Our Collection
                        </h1>
                        <p className="text-sm lg:text-base max-w-lg mx-auto" style={{ color: '#6B7280' }}>
                            Discover handcrafted pieces that celebrate Indian elegance and feminine grace
                        </p>
                    </div>

                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                        {/* Filters & Sort */}
                        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-8">
                            {/* Category Pills */}
                            <div className="flex flex-wrap gap-2">
                                {categories.map((cat) => (
                                    <button
                                        key={cat}
                                        onClick={() => { setActiveFilter(cat); setCurrentPage(1); }}
                                        className="px-4 py-2 rounded-full text-sm font-medium transition-all duration-300"
                                        style={{
                                            backgroundColor: activeFilter === cat ? '#BE185D' : '#FDF2F8',
                                            color: activeFilter === cat ? '#FFFFFF' : '#6B7280',
                                            border: activeFilter === cat ? '1px solid #BE185D' : '1px solid #F9A8D4',
                                        }}
                                    >
                                        {cat}
                                    </button>
                                ))}
                            </div>

                            {/* Sort */}
                            <select
                                value={sortBy}
                                onChange={(e) => setSortBy(e.target.value)}
                                className="px-4 py-2 rounded-lg text-sm outline-none cursor-pointer"
                                style={{
                                    backgroundColor: '#FDF2F8',
                                    color: '#1A1A1A',
                                    border: '1px solid #F9A8D4',
                                    fontFamily: "'DM Sans', sans-serif",
                                }}
                            >
                                {sortOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                        </div>

                        {/* Product Count */}
                        <p className="text-sm mb-6" style={{ color: '#6B7280' }}>
                            Showing {sortedProducts.length} product{sortedProducts.length !== 1 ? 's' : ''}
                        </p>

                        {/* Product Grid */}
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6">
                            {sortedProducts.map((product) => (
                                <div
                                    key={product.id}
                                    onClick={() => navigate(`/template8/product/${product.id}`)}
                                    onMouseEnter={() => setHoveredCard(product.id)}
                                    onMouseLeave={() => setHoveredCard(null)}
                                    className="cursor-pointer group rounded-xl overflow-hidden"
                                    style={{
                                        backgroundColor: '#FFFFFF',
                                        transition: 'all 0.3s ease',
                                        boxShadow: hoveredCard === product.id ? '0 8px 30px rgba(190,24,93,0.12)' : '0 2px 8px rgba(0,0,0,0.04)',
                                        transform: hoveredCard === product.id ? 'translateY(-4px)' : 'translateY(0)',
                                    }}
                                >
                                    <div className="relative aspect-[3/4] overflow-hidden">
                                        <img
                                            src={product.image}
                                            alt={product.name}
                                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                        />
                                        {product.badge && (
                                            <span
                                                className="absolute top-3 left-3 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider"
                                                style={{ backgroundColor: '#F9A8D4', color: '#9D174D' }}
                                            >
                                                {product.badge}
                                            </span>
                                        )}
                                        <button
                                            onClick={(e) => toggleWishlist(e, product.id)}
                                            className="absolute top-3 right-3 w-9 h-9 rounded-full flex items-center justify-center transition-all"
                                            style={{ backgroundColor: 'rgba(255,255,255,0.9)' }}
                                        >
                                            <Heart
                                                size={18}
                                                style={{
                                                    color: wishlist[product.id] ? '#BE185D' : '#6B7280',
                                                    fill: wishlist[product.id] ? '#BE185D' : 'none',
                                                }}
                                            />
                                        </button>
                                    </div>
                                    <div className="p-4">
                                        <h3 className="text-sm font-medium mb-1 line-clamp-1" style={{ color: '#1A1A1A' }}>{product.name}</h3>
                                        <p className="text-sm font-bold" style={{ color: '#BE185D' }}>{`\u20B9${product.price.toLocaleString('en-IN')}`}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Pagination */}
                        <div className="flex items-center justify-center gap-2 mt-12">
                            <button
                                onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                                disabled={currentPage === 1}
                                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors disabled:opacity-30"
                                style={{ border: '1px solid #F9A8D4', color: '#BE185D' }}
                            >
                                <ChevronLeft size={18} />
                            </button>
                            {[...Array(totalPages)].map((_, i) => (
                                <button
                                    key={i}
                                    onClick={() => setCurrentPage(i + 1)}
                                    className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium transition-colors"
                                    style={{
                                        backgroundColor: currentPage === i + 1 ? '#BE185D' : 'transparent',
                                        color: currentPage === i + 1 ? '#FFFFFF' : '#6B7280',
                                        border: currentPage === i + 1 ? '1px solid #BE185D' : '1px solid #F9A8D4',
                                    }}
                                >
                                    {i + 1}
                                </button>
                            ))}
                            <button
                                onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                                disabled={currentPage === totalPages}
                                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors disabled:opacity-30"
                                style={{ border: '1px solid #F9A8D4', color: '#BE185D' }}
                            >
                                <ChevronRight size={18} />
                            </button>
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Template8Shop;
